import Vue from 'vue'
import 'normalize.css/normalize.css' // CSS reset
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss'
import '@/styles/common.scss'
import * as $enum from './utils/enum'

import authButtonComponent from '@/components/authButton/index'
import $ from 'jquery'

import * as filters from '@/utils/index' // 全局 filters
import Router from 'vue-router'

import '@/utils/permission' // permission控制
// require('./mock')

Vue.prototype.$enum = $enum
Vue.prototype.$jquery = $
Vue.use(authButtonComponent)
Vue.config.productionTip = false
// 注册滚动条加载触发事件v-loadmore绑定
Vue.directive('loadmore', {
  bind (el, binding) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    SELECTWRAP_DOM.addEventListener('scroll', function () {
      const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight
      if (CONDITION) {
        binding.value()
      }
    })
  }
})

Vue.use(Element)

const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}

// 注册全局 filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
